import { render, staticRenderFns } from "./principalContactForm.vue?vue&type=template&id=2d587952&"
import script from "./principalContactForm.vue?vue&type=script&lang=ts&"
export * from "./principalContactForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports